/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Recommendation from 'Shared/components/Recommendation';
import {
  getRecommendations,
  updateRecommendation,
  externalAPICallFromRecommendation,
  addRecommendationClick,
} from 'Shared/actions/recommendations';
import Spinner from 'Shared/components/Spinner';

import SalesforceRecordModal from 'Shared/components/SalesforceRecordModal/SalesforceRecordModal';

class Recommendations extends Component {
  constructor(props) {
    super(props);

    this.state = { loading: false, accountModal: false };

    this.clickedLink = this.clickedLink.bind(this);
    this.callExternalAPI = this.callExternalAPI.bind(this);
    this.openAccountModal = this.openAccountModal.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });

    const { dispatch, user, app } = this.props;
    dispatch(getRecommendations(user.id, { token: user.token })).then(() => this.setState({ loading: false }));

    window.analytics.track('Viewed Nudgebot Alerts', {
      app_id: app.id,
    });
  }

  clickedButton(userId, recId, type) {
    const { dispatch, user } = this.props;
    dispatch(updateRecommendation(userId, recId, type, { token: user.token }));
  }

  clickedLink(userId, recId, key, link) {
    this.props.dispatch(addRecommendationClick({ recommendation_id: recId, button_key: key, button_link: link }));
  }

  openAccountModal(account) {
    this.setState({ account }, () => this.setState({ accountModal: !this.state.accountModal }));
  }

  callExternalAPI({ recommendation_id, button_key }) {
    this.props.dispatch(externalAPICallFromRecommendation({ recommendation_id, button_key }));
  }

  recommendationsSubList({recommendations, disabled, user}) {
    return (recommendations.map(rec => (
      <div className="" key={rec.id}>
        {!disabled && (
          <Recommendation
            hideToggle
            recommendation={rec}
            callExternalAPI={this.callExternalAPI}
            clickedLink={(key, link) => this.clickedLink(user.id, rec.id, key, link)}
            openAccountModal={this.openAccountModal}
            openProfile={() => null}
            clickedDismiss={() => this.clickedButton(user.id, rec.id, 'dismissed_at')}
            clickedCheckbox={() => this.clickedButton(user.id, rec.id, 'completed_at')}
          />
        )}
        {disabled && (
          <Recommendation
            hideToggle
            recommendation={rec}
            callExternalAPI={() => {
              alert('Action buttons are disabled.');
            }}
            clickedLink={() => {}}
            clickedDismiss={() => {}}
            clickedCheckbox={() => {}}
          />
        )}
      </div>
    )));
  }

  render() {
    const { user, recommendations, hideHeader, disabled } = this.props;

    const recommendations_filtered = recommendations
      .filter(rec => !rec.dismissed_at)
      .filter(rec => rec.marked_as === 'verified')
      .filter(rec => rec.still_valid)
      .filter(rec => !rec.snoozed)
      .filter(rec => rec.type.toLowerCase().includes('salesforce'));

    const three_day_threshold = moment().subtract(3,'day');
    const seven_day_threshold = moment().subtract(7,'day');

    const recommendations_less_than_3_days_old = recommendations_filtered.filter(rec => !rec.created_at || moment(rec.created_at) > three_day_threshold);
    const recommendations_more_than_3_less_than_7_days_old = recommendations_filtered.filter(rec => rec.created_at && moment(rec.created_at) <= three_day_threshold && moment(rec.created_at) > seven_day_threshold);
    const recommendations_more_than_7_days_old = recommendations_filtered.filter(rec => rec.created_at && moment(rec.created_at) <= seven_day_threshold);

    return (
      <div className="recommendation-settings py-2">
        {!hideHeader && (
          <>
            <h3>Sales Assistant</h3>
            <p className="text-muted">View and resolve your CRM Data Quality nudges</p>
          </>
        )}

        {recommendations_filtered.length === 0 && !this.state.loading && (
          <p className="font-weight-bold text-center">No nudges found at this time</p>
        )}

        <div className="border-top">
          <Spinner activeIf={this.state.loading} />
          {this.recommendationsSubList({recommendations: recommendations_less_than_3_days_old, disabled, user})}
          {(recommendations_more_than_3_less_than_7_days_old.length > 0) && (<h4 className="mt-4 text-warning">
            {'3+ days old'}
          </h4>)}
          {this.recommendationsSubList({recommendations: recommendations_more_than_3_less_than_7_days_old, disabled, user})}
          {(recommendations_more_than_7_days_old.length > 0) && (<h4 className="mt-4 text-danger">
            {'7+ days old'}
          </h4>)}
          {this.recommendationsSubList({recommendations: recommendations_more_than_7_days_old, disabled, user})}
        </div>

        <SalesforceRecordModal />
      </div>
    );
  }
}

Recommendations.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  app: state.app,
  user: ownProps.user || state.user,
  recommendations: state.recommendations[(ownProps.user || state.user).id] || [],
});

export default connect(mapStateToProps)(Recommendations);
